import * as z from 'zod/v4';

export const eventNumberSchema = z.coerce.number().int().positive().brand<'EventNumber'>();

/**
 * Branded type for event number.
 */
export type EventNumber = z.infer<typeof eventNumberSchema>;

/**
 * Utility function to create a EventNumber.
 *
 * @param value input value to check
 * @returns returns true or false if the value matches pattern for event number.
 */
export function isEventNumber(value: unknown): value is EventNumber {
  if (typeof value !== 'number') {
    return false;
  }

  if (!Number.isInteger(value)) {
    return false;
  }

  if (value < 1) {
    return false;
  }

  return true;
}

/**
 * Utility function to create an EventNumber.
 *
 * @param value input value to check
 * @returns Throws error if input dosen't match event number, otherwise returns the event id with branded type.
 * @throws {Error} if input dosen't match event number.
 */
export function getEventNumber(value: unknown): EventNumber {
  const isValidEventNumber = isEventNumber(value);

  if (!isValidEventNumber) {
    throw new Error('Invalid EventNumber');
  }

  return value;
}
